export default __webpack_public_path__ + "static/media/TicketingIcon.fabbbdc6.svg";